"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onConsentGiven = void 0;
const utils_1 = require("../../utils");
const onConsentGiven = (callbacks) => {
    // OptanonWrapper callback is called after OneTrust banner script execution and consent changes
    window.OptanonWrapper = () => {
        if (!(0, utils_1.isCookieConsentGiven)()) {
            return;
        }
        callbacks.forEach(({ requiredCategoryIds, callback }) => {
            if (requiredCategoryIds.every(utils_1.isActiveCategoryId)) {
                callback();
            }
        });
    };
};
exports.onConsentGiven = onConsentGiven;
//# sourceMappingURL=onConsentGiven.js.map